import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_scrollbar, { style: {"height":"calc(100vh - 60px)","min-height":"600px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, {
            "default-active": this.$route.path,
            "unique-opened": "",
            router: "",
            class: "el-menu-vertical-demo",
            collapse: _ctx.isCollapse,
            onOpen: _ctx.handleOpen,
            onClose: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  (item.children.length)
                    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                        key: 0,
                        index: item.path
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.menuName), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (list, i) => {
                            return (_openBlock(), _createBlock(_component_el_menu_item, {
                              index: list.path,
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(list.menuName), 1)
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["index"]))
                    : (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: 1,
                        index: item.path
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.menuName), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_icon_menu)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["index"]))
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["default-active", "collapse", "onOpen", "onClose"])
        ]),
        _: 1
      })
    ])
  ]))
}